import React from "react";
import { IState } from "../../../../../common/state/IState";
import { umSpPageDynamicContentSelector } from "../selectors";
import { useSelector } from "react-redux";

const i18n = {
    logoPlaceHolder: "logo",
};

const selector = (s: IState) =>
    umSpPageDynamicContentSelector(s)?.info?.Logo?.Light;

export function UmSpDcLogoElement({ className }) {
    const logoUrl = useSelector(selector);

    return (
        <div className={className}>
            {logoUrl ? <img src={logoUrl} alt="logo" /> : i18n.logoPlaceHolder}
        </div>
    );
}
